import { createSlice } from '@reduxjs/toolkit';
import { post } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/independencePayment/paymentIntent',
  initialState: {
    isLoading: false,
    error: null,

    paymentIntentID: null,
    stripeCustomerID: null,
    clientSecret: null,
    paymentTypeID: null,
    insuranceContractID: null,
    amount: null,
    currency: null
  },
  reducers: {
    // createContractAndStripePaymentIntent
    createContractAndStripePaymentIntentRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    createContractAndStripePaymentIntentSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.paymentIntentID = payload.paymentIntentID;
      state.stripeCustomerID = payload.stripeCustomerID;
      state.clientSecret = payload.clientSecret;
      state.paymentTypeID = payload.paymentTypeID;
      state.insuranceContractID = payload.insuranceContractID;
      state.amount = payload.amount;
      state.currency = payload.currency;
    },
    createContractAndStripePaymentIntentFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // submitApplicationSuccess
    submitApplicationSuccessRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    submitApplicationSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.paymentIntentID = payload.paymentIntentID;
      state.stripeCustomerID = payload.stripeCustomerID;
      state.clientSecret = payload.clientSecret;
      state.paymentTypeID = payload.paymentTypeID;
      state.insuranceContractID = payload.insuranceContractID;
      state.amount = payload.amount;
      state.currency = payload.currency;
    },
    submitApplicationFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const createContractAndStripePaymentIntent = () => async (dispatch, useState) => {
  const { applicationBundleId } = useState().nomadInsurance.application.offer;

  dispatch(actions.submitApplicationSuccessRequest());

  try {
    const response = await post(
      `/applications/v1/${applicationBundleId}/submit`,
      undefined,
      { isNIOrchestrator: true }
    );

    dispatch(actions.submitApplicationSuccess(response));
  } catch (error) {
    dispatch(actions.submitApplicationFailure(error));
  }
};
